<section class="trust-security-section py-5">
  <div class="container">
    <div class="row mb-4">
      <div class="col-lg-8 mx-auto text-center">
        <h2 class="benefit-section-title">Core product capabilities</h2>
        <p class="benefit-section-intro">Manage memberships, renewals, events, payments, applications, reporting, and directories in one system—so nothing lives in a side spreadsheet by default.</p>
      </div>
    </div>
    <div class="benefits-grid">
      <div class="benefit-grid-cell" *ngFor="let item of benefitItems">
        <div class="benefit-card h-100">
          <div class="benefit-icon-wrap">
            <mat-icon color="primary" class="benefit-icon">{{ item.icon }}</mat-icon>
          </div>
          <h3 class="benefit-title">{{ item.title }}</h3>
          <p class="benefit-description">{{ item.description }}</p>
        </div>
      </div>
    </div>
  </div>
</section>
